import { cn } from '@/lib/utils'

type ContainerProps = {
  children: React.ReactNode
  className?: string
  as?: React.ElementType
  /**
   * `default` is the editorial measure from the brand system (1152px, the
   * stock token nearest 1140). `wide` (1280px) is for data-dense dashboards
   * and tables in the portal and admin console.
   */
  size?: 'default' | 'wide'
}

export default function Container({
  children,
  className,
  as: Tag = 'div',
  size = 'default',
}: ContainerProps) {
  return (
    <Tag
      className={cn(
        'mx-auto w-full px-4 sm:px-6 lg:px-8',
        size === 'wide' ? 'max-w-7xl' : 'max-w-6xl',
        className
      )}
    >
      {children}
    </Tag>
  )
}
